
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import PartsSelector from "@common/src/components/scope/parts-selector/index.vue";
import TempPurchaseDialog from "@/components/scope/temp-purchase-dialog/index.vue";
import _ from "lodash-es";
import t from "@common/src/i18n/t";

const app = namespace("app");
const parts = namespace("parts");

@Component({ components: { PartsSelector, TempPurchaseDialog } })
export default class PartsReplaceDialog extends Vue {
  @parts.Action saveTempParts;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @parts.Action getPartsInventoryList;
  @Prop({ default: false, type: Boolean }) visible;
  @Prop({ default: () => ({}), type: Object }) orderData: any;
  orderPartsList: any = [];
  created() {
    this.getPartsLists();
  }
  partsList: any = [];
  getPartsLists(name = "") {
    this.getPartsInventoryList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name
    }).then(data => {
      this.partsList = data?.data?.list || [];
    });
  }
  handleConfirmReplace() {
    for (let i = 0; i < this.orderPartsList.length; i++) {
      const row = this.orderPartsList[i];
      if (!row.partsCode) {
        return this.$message.error(t("v3_2_0.please-select-the-actual-spare-parts-the-store"));
      }
    }
    this.$emit("submit", this.orderPartsList);
  }
  handleChooseParts(partsCode, index, parts) {
    const findParts = this.partsList.find(parts => parts.partsCode === partsCode);
    parts.newItemCode = partsCode;
    parts.itemType = 2;
    parts.partsType = findParts.partsType;
  }
  @Watch("orderData", { deep: true })
  orderDataChange(orderData) {
    if (orderData.orderNo) {
      this.orderPartsList = _.cloneDeep(orderData.partsDetail)
        .filter(parts => parts.inventoryShortage)
        .map(item => {
          const data = _.pick(item, ["partsName", "orderDetailNo", "partsType"]);
          data.partsType = "1";
          return data;
        });
    }
  }
  handleClose() {
    this.$emit("update:visible", false);
  }
  curIndex: number = 0;
  handleShowAddTempParts(index) {
    this.curIndex = index;
    (this.$refs["tempPurDialog"] as any).open();
  }
  handleTempSubmit(data) {
    this.saveTempParts(data).then(res => {
      const partsItem = {
        partsNameDesc: data.partsName,
        partsCode: res.data.partsCode,
        partsType: "2"
      };
      this.partsList.push(partsItem);
      this.orderPartsList[this.curIndex].partsCode = res.data.partsCode;
      this.handleChooseParts(res.data.partsCode, this.curIndex, this.orderPartsList[this.curIndex]);
    });
  }
}
